export default __webpack_public_path__ + "static/media/DENTISTCERTIFICATEA5_BLANK.b8cd40c5.png";